import {
  CreditcardForPurchaseRepository,
  FrontApiRepositoryForPurchase,
} from '@/models/payment/creditcard/context/for-purchase/repository'
import {
  CreditcardForSubscriptionRepository,
  FrontApiRepositoryForSubscription,
} from '@/models/payment/creditcard/context/for-subscription/repository'
import { CreditcardRegistrationDependencies } from '@/models/payment/creditcard/service/register-new-creditcard'
import { CreditcardServiceForPurchase } from '@/services/api/creditcard'
import {
  CreditcardServiceForSubscription,
} from '@/services/api/subscription/payment/creditcard-service-for-subscription'
import { getCreditcardPaymentProvierServiceConfig } from '@/services/payment'

/*
 * クレジットカードの新規登録に必要な依存パラメータを構築する.
 *
 * 文脈によってオブジェクトの構築方法が異なるので、各文脈に適した構成をここで定義している.
 */

export const purchaseContext: () => CreditcardRegistrationDependencies = () => ({
  repository: {
    main: convertPurchaseRepositoryForDependency(
      new FrontApiRepositoryForPurchase(
        new CreditcardServiceForPurchase(),
        getCreditcardPaymentProvierServiceConfig().forPurchase
      )
    ),
    sub: convertSubscriptionRepositoryForDependency(
      new FrontApiRepositoryForSubscription(
        new CreditcardServiceForSubscription(),
        getCreditcardPaymentProvierServiceConfig().forSubscription
      )
    ),
  },
})
export const subscriptionContext: () => CreditcardRegistrationDependencies = () => ({
  repository: {
    main: convertSubscriptionRepositoryForDependency(
      new FrontApiRepositoryForSubscription(
        new CreditcardServiceForSubscription(),
        getCreditcardPaymentProvierServiceConfig().forSubscription
      )
    ),
    sub: convertPurchaseRepositoryForDependency(
      new FrontApiRepositoryForPurchase(
        new CreditcardServiceForPurchase(),
        getCreditcardPaymentProvierServiceConfig().forPurchase
      )
    ),
  },
})

const convertPurchaseRepositoryForDependency = (repo: CreditcardForPurchaseRepository) => ({
  register: (card, user, context) => repo.register(card, user, context),
  getRegistered: () => repo.listRegistered(),
})
const convertSubscriptionRepositoryForDependency = (repo: CreditcardForSubscriptionRepository) => ({
  register: (card, user, context) => repo.register(card, user, context),
  getRegistered: () => repo.findRegistered().then(opt => opt.fold(
    [],
    card => [card]
  )),
})
